import React from 'react'
import { uni1d800 } from '@/utils/extras'
import { ArtData } from '@/database/art'

const ChatBar = ({ artData }: { artData?: ArtData }) => {
    return artData ? (
        <div className="">
            <h4 className={uni1d800.className}>{'\uD836\uDE17 Your Comments \u200C\u200C\uD836\uDE17'}</h4>
            <span className={'small'}>&nbsp;</span>
        </div>
    ) : (
        <div className="">
            <h4 className={uni1d800.className}>\uD836\uDE17 Chat \uD836\uDE17</h4>
            <span className={'small'}>&nbsp;</span>
        </div>
    )
}

export default ChatBar
